module.exports = __webpack_public_path__ + "img/NOL.93261679.jpg";